function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { GetDeactivatedUsersResponse as GetDeactivatedUsersResponseCore } from "@amzn/coral_com-amazon-passportusermanagementservice";
import { modelRegistrySingleton } from "@amzn/ihm-js-coral-client";
import FULLY_QUALIFIED_TYPE_NAMES from "../constants/coralOperationTypes";
/**
 * Extended class to override the serialization behavior and modify the type definition.
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */ var GetDeactivatedUsersResponse = /*#__PURE__*/ function(GetDeactivatedUsersResponseCore1) {
    "use strict";
    _inherits(GetDeactivatedUsersResponse, GetDeactivatedUsersResponseCore1);
    var _super = _createSuper(GetDeactivatedUsersResponse);
    function GetDeactivatedUsersResponse() {
        _classCallCheck(this, GetDeactivatedUsersResponse);
        return _super.apply(this, arguments);
    }
    GetDeactivatedUsersResponse.fromJson = function fromJson(param) {
        var userList = param.userList;
        return GetDeactivatedUsersResponse.clone({
            userList: userList
        });
    };
    return GetDeactivatedUsersResponse;
}(GetDeactivatedUsersResponseCore);
GetDeactivatedUsersResponse.fullyQualifiedTypeName = FULLY_QUALIFIED_TYPE_NAMES.GetDeactivatedUsers;
// Register concrete types for serialization/deserialization
modelRegistrySingleton.registerType(GetDeactivatedUsersResponse);
export default GetDeactivatedUsersResponse;

//# sourceMappingURL=GetDeactivatedUsersResponse.js.map